
exports.sagaError = (error) => {
    if (error.response) {
        let { message } = error.response.data;

        // if error is a 401, override the id and message so only 1 message displays
        if (error.response.status === 401 && message.toLowerCase() === 'bad token') {
            return {
                id: 'badtoken',
                message: 'You have been logged out. Please login to continue.',
                status: 'success',
            };
        }

        if (error.response.data.message === 'An internal server error occurred') {
            message = 'We\'re having issues retrieving data, and have been notified. We\'re looking into it.';
        }
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return {
            message,
            status: error.response.status
        };
    }
    // } else if (error.request) {
    //     // The request was made but no response was received
    //     // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    //     // http.ClientRequest in node.js
    //     console.log(error.request);
    // }

    // Something happened in setting up the request that triggered an Error
    return {
        message: error.message,
        status: 'error'
    };
};



// WEBPACK FOOTER //
// ./src/helpers/handleGenericSagaError.js